import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '@/store'
import messages from '@/i18n/index.yaml'

Vue.use(VueI18n)

export const commonI18n = new VueI18n({
  locale: 'en', // set locale
  messages
})

// 定义获取公共翻译的方法
Vue.prototype.$ct = function(...arg) {
  return commonI18n.t(...arg)
}

// 转换path为国际化跳转
export function iPath(url) {
  const locale = store.state.locale
  if (typeof url === 'object') {
    let { path, name, params = {} } = url
    const { query } = url
    if (locale !== 'en') {
      if (path) {
        path = '/' + locale + path
      }
      if (name) {
        name = 'lang_' + name
        params = Object.assign({}, params, { lang: locale })
      }
    }
    return { path, name, query, params }
  } else {
    return locale === 'en' ? url : '/' + locale + url
  }
}
